import React from 'react';

const tokenColors= [
    "red",
    "orange",
    "blue",
    "green",
    "lightgreen",
    "limegreen",
    "gray",
    "brown",
    "pink",
    "lightblue",
    "purple",
    "yellow"
]

function AvailableTokens({ gameContainerCount = 6, usedTokens= [""], handleClick = (e : React.MouseEvent<HTMLDivElement, MouseEvent>) => { } }) {

    const colors = tokenColors.slice(0, gameContainerCount - 2);

    const reducer = (allColors:any, color:string) => {
        if (color in allColors) {
            allColors[color]++
        } else {
            allColors[color] = 1
        }
        return allColors;
    }
    const countedColors = usedTokens.reduce(reducer, {})

    var meaninglessIdx = 0;

//     return (
//         <>
//             <div>Available Tokens</div>
//             {colors.map(color => (
//                 <div className="availableTokenContainer" color={color} onClick={handleClick} key={meaninglessIdx++}>
//                     {Array.from({ length: 4 }).map((value, index) => (
//                         <div key={meaninglessIdx++}>
//                             <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
//                                 <circle cx="12" cy="12" r="12" fill={index >= (countedColors[color] || 0) ? color : "transparent"}/>
//                             </svg>
//                         </div>
//                     ))}
//                 </div>
//             ))}
//         </>
//   );
  return (
    <>
        <h3>Available Tokens</h3>
        {colors.map(color => (
            <div className="availableTokenContainer" color={color} onClick={handleClick} key={meaninglessIdx++}>
                {Array.from({ length: 4 - (countedColors[color] ?? 0) }).map((value, index) => (
                    <div key={meaninglessIdx++}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
                            <circle cx="12" cy="12" r="12" fill={color}/>
                        </svg>
                    </div>
                ))}
            </div>
        ))}
    </>
);
}

export default AvailableTokens;
